import { Mark } from '@tiptap/core'

const TextColor = Mark.create({
  name: 'textcolor',

  addOptions () {
    return {
      color: [null]
    }
  },

  addAttributes () {
    return {
      color: {
        default: null,
        parseHTML: element => {
          return element.style.color || element.getAttribute('data-color') || element.getAttribute('color') || null
        },
        renderHTML: attrs => {
          if (!attrs.color) {
            return {}
          }

          return {
            style: `color:${attrs.color}`
          }
        }
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'span',
        getAttrs: element => {
          const color = element.style.color || element.getAttribute('data-color') || element.getAttribute('color')

          if (!color) {
            return false
          }

          return null
        }
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      textcolor: attrs => ({ commands }) => {
        const value = attrs && attrs.color ? attrs.color : null

        if (!value) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, { color: value })
      }
    }
  }
})

export default TextColor
